<template>
  <Modal ref="modal" :title="title">
    <div class="modal-container">
      <p>{{ message }}</p>

      <div class="buttons">
        <Button @handle:click="close" text="Cancelar" color="danger" />
        <Button @handle:click="() => onConfirm(modelId)" text="Confirmar" color="primary" />
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '../core/Modal'
import Button from '../core/Button'

export default {
  name: 'ConfirmModal',
  components: {
    Modal,
    Button,
  },
  data() {
    return {
      modelId: null,
    }
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
    },
    onConfirm: Function,
  },
  methods: {
    open(id) {
      this.modelId = id

      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-container {
  max-width: 30vw;
  display: flex;
  flex-direction: column;

  .buttons {
    align-self: flex-end;
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}
</style>